module.exports = __webpack_public_path__ + "img/payment.625a86dc.svg";